import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  return (
    <section className="w-full py-20 md:py-28 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-chat-quote-line text-accent-700 text-lg"></i>
          </div>
          <span className="font-label text-xs text-accent-700 font-medium uppercase tracking-wider">Reviews</span>
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-accent-800 mt-2">
            Community Trust
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="md:col-span-1 space-y-5">
            {testimonials.slice(0, 2).map((t) => (
              <div key={t.name} className="bg-white rounded-2xl p-6">
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="font-label text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
                <i className="ri-double-quotes-l text-accent-200 text-2xl block mb-2"></i>
                <p className="text-foreground-600 text-sm leading-relaxed">{t.text}</p>
              </div>
            ))}
          </div>

          <div className="md:col-span-1">
            {testimonials[2] && (
              <div className="relative h-full min-h-[400px] rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Candid%20lifestyle%20portrait%20of%20stylish%20person%20in%20oversized%20camel%20wool%20coat%20and%20dark%20denim%20walking%20through%20sunlit%20city%20street%20with%20autumn%20leaves%2C%20warm%20golden%20hour%20backlighting%2C%20editorial%20street%20style%20photography%2C%20natural%20candid%20expression%2C%20soft%20bokeh%20background%2C%20sophisticated%20urban%20aesthetic&width=600&height=800&seq=testimonial-v2-019&orientation=portrait"
                  alt=""
                  className="absolute inset-0 w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-6 pt-16">
                  <p className="text-white font-label text-sm font-semibold">{testimonials[2].name}</p>
                  <p className="text-white/70 text-xs">{testimonials[2].role}</p>
                </div>
              </div>
            )}
          </div>

          <div className="md:col-span-1 space-y-5">
            {testimonials.slice(3, 5).map((t) => (
              <div key={t.name} className="bg-white rounded-2xl p-6">
                <i className="ri-double-quotes-l text-accent-200 text-2xl block mb-2"></i>
                <p className="text-foreground-600 text-sm leading-relaxed mb-4">{t.text}</p>
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img src={t.avatar} alt={t.name} className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <p className="font-label text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.role}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 md:mt-12 bg-white rounded-2xl p-6 md:p-8 relative overflow-hidden">
          <div className="flex flex-col md:flex-row items-start gap-6">
            <div className="flex-1">
              <i className="ri-double-quotes-l text-accent-100 text-4xl block mb-3"></i>
              <p className="text-foreground-700 text-base leading-relaxed mb-4">
                I have tried several product databases before, but Superbuy Spreadsheet stands out because of the regular updates and community-driven recommendations. It feels curated, not automated. The organized Superbuy spreadsheet links save me countless hours every week.
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={testimonials[3].avatar} alt={testimonials[3].name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <p className="font-label text-sm font-semibold text-foreground-900">{testimonials[3].name}</p>
                  <p className="text-xs text-foreground-500">{testimonials[3].role}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}